import api from './api';

const partnerDashboardService = {
  // Get partner dashboard statistics
  getStats: async () => {
    try {
      const response = await api.get('/partners/stats/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch dashboard stats'
      };
    }
  },
};

export default partnerDashboardService;
